var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-box flex flex_jus_between"},[_c('div',{staticClass:"header flex flex_jus_between"},[_c('p',{staticClass:"title"},[_vm._v("NEWSFLOW")]),_vm._v(" "),_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.timeView))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca4898c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Header.vue
// module id = null
// module chunks = 